import React from 'react';

import useWindowSize from '../hooks/useWindowSize';
import { SettingBar } from '../containers/SettingBar';

export const LayersButtonsSection = () => {
  const [width] = useWindowSize();
  const [nbButton, setNbButton] = React.useState(6);

  React.useEffect(() => {
    if(width < 1800 && width >= 1600) {
      setNbButton(4);
    } else if(width < 1600 && width >= 1400) {
      setNbButton(3);
    } else if(width < 1400 && width >= 1200) {
      setNbButton(2);
    } else if (width < 1200) {
      setNbButton(2);
    } else {
      setNbButton(5);
    }
  }, [width]);

  return (
    <SettingBar nbButton={nbButton}/>
  );
};